"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TopSection = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useBreakPoint = require("../../../common/useBreakPoint");
var _PagePicture = _interopRequireDefault(require("../PagePicture/PagePicture"));
var _GSemployeeRoleItem = _interopRequireDefault(require("../GSemployeeRole/GSemployeeRoleItem"));
var _ArticleBoxArea = _interopRequireDefault(require("../ArticleBoxArea/ArticleBoxArea"));
var _removeTags = require("../../../common/removeTags");
var _StatusIcon = require("../../StatusIcon/StatusIcon");
var _PageMedia = _interopRequireDefault(require("../PageMedia/PageMedia"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.section-container {\n  display: flex;\n  flex-direction: column; }\n  .section-container .section-content {\n    display: flex;\n    flex-direction: column; }\n  .section-container .top-container {\n    display: grid;\n    row-gap: 16px;\n    background-color: #fff; }\n    .section-container .top-container .item {\n      width: 100%;\n      background-color: #f4f4f4;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      cursor: pointer; }\n      .section-container .top-container .item span {\n        font-size: 16px;\n        width: 100%;\n        line-height: 1;\n        border-width: 1px;\n        margin-left: 16px;\n        color: #e41b13; }\n    .section-container .top-container .item.active span {\n      color: #fff; }\n    .section-container .top-container .first-in-row {\n      border-bottom-left-radius: 4px;\n      border-top-left-radius: 4px; }\n    .section-container .top-container .last-in-row {\n      border-bottom-right-radius: 4px;\n      border-top-right-radius: 4px; }\n    .section-container .top-container .item.active {\n      background-color: #e41b13; }\n    .section-container .top-container .icon {\n      padding-right: 10px;\n      border-width: 1px; }\n    .section-container .top-container span {\n      padding-right: 4px; }\n  .section-container .bottom-section-container {\n    overflow: hidden; }\n    .section-container .bottom-section-container .section-element {\n      z-index: -2;\n      animation: 0.6s ease-out 0s 1 sectionElementAnimation; }\n      .section-container .bottom-section-container .section-element .element {\n        animation: 0.6s ease-out 0s 1 sectionElementAnimation; }\n    .section-container .bottom-section-container .title {\n      width: 75%; }\n  .section-container .copyright-container p {\n    padding-left: 0px; }\n  @media (max-width: 42rem) {\n    .section-container span {\n      margin-left: 0px !important;\n      margin: auto;\n      text-align: center; } }\n\n.section-container .grid {\n  display: grid;\n  grid-template-columns: 75% 25%; }\n\n@media (max-width: 66rem) {\n  .section-container .grid {\n    grid-template-columns: 100%; }\n    .section-container .grid .section-content {\n      padding-right: 0px; } }\n\n@media (max-width: 42rem) {\n  .section-container .bottom-section-container .title {\n    width: 100%; } }\n\n@keyframes sectionElementAnimation {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n";
  const fileName = "Section_Section";
  const element = document.querySelector("style[data-sass-component='Section_Section']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const removeSpecialChars = str => {
  return str.replaceAll(/[áàâäa]/g, 'a').replaceAll(/[èéë]/g, 'e').replaceAll(/[íìîï]/g, 'i').replaceAll(/[öòó]/g, 'o').replaceAll(/[úùûü]/g, 'u');
};
const removeSpaces = str => {
  return str.replaceAll(' ', '');
};
const formatSectionTitle = str => {
  return removeSpaces(removeSpecialChars((0, _removeTags.removeTags)(str))).toLowerCase();
};
const TopSection = _ref => {
  let {
    item,
    array,
    selected,
    setSelected,
    history
  } = _ref;
  const {
    isMobile,
    isTablet
  } = (0, _useBreakPoint.useBreakPoint)();
  const columns = isMobile ? item.columns_mobile || 2 : isTablet ? item.columns_tablet || 3 : item.columns || 4;
  const elmentsPerRow = columns > array.length ? array.length : columns;
  (0, _react.useEffect)(() => {
    const selectedItem = formatSectionTitle(decodeURIComponent(history?.location?.hash || ''));
    const ids = array.map(el => `#${el.id || el.title}`);
    let index = ids.indexOf(selectedItem);
    if (index === -1) {
      const titles = array.map(el => formatSectionTitle(`#${el.title}`));
      index = titles.indexOf(selectedItem.toLowerCase());
      if (index >= 0) {
        if (selected !== index) history.push(history?.location?.pathname + ids[index]);
      } else {
        index = 0;
      }
    }
    setSelected(index);
  }, [selected, history?.location]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "top-container",
    style: {
      gridTemplateColumns: `repeat(${elmentsPerRow}, 1fr)`
    }
  }, array?.map((el, index) => {
    const isSelected = selected === index;
    const isFirst = index === 0 || index % elmentsPerRow === 0;
    const isLast = index === array.length - 1 || index % elmentsPerRow === elmentsPerRow - 1;
    const title = el.title?.replace('<p>', '').replace('</p>', '')?.replace('&nbsp;', '');
    let showIcon = false;
    if (el.status) {
      showIcon = true;
    }
    const isCenterElement = !isSelected && !isLast && selected !== index + 1;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: el.id || el.title.toLowerCase(),
      className: `item${isSelected ? ' active' : ''} ${isFirst ? ' first-in-row' : ''} ${isLast ? ' last-in-row' : ''}`,
      onClick: () => {
        setSelected(index);
        history.push(history?.location?.pathname + '#' + (el.id || el.title));
      },
      key: index
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: `${isSelected ? 'sia-text-09' : 'sia-text-10'} ${!showIcon && isCenterElement ? 'sia-border-02-right' : ''}`,
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), showIcon && /*#__PURE__*/_react.default.createElement("div", {
      className: `icon ${isCenterElement ? 'sia-border-02-right' : ''}`
    }, /*#__PURE__*/_react.default.createElement(_StatusIcon.StatusIcon, {
      status: el.status,
      color: isSelected ? 'SIAwhite' : ''
    })));
  }));
};
exports.TopSection = TopSection;
const BottomSection = _ref2 => {
  let {
    element,
    Item,
    lang,
    history,
    getParagraph,
    cachedValues,
    setCachedValues,
    ...rest
  } = _ref2;
  const [data, setData] = (0, _react.useState)([]);
  const title = element.section_element_title && element.section_element_title[0];
  const image_el = element.image && element.image.length > 0 ? element.image[0][0] : undefined;
  const image = image_el && !(image_el?.teaser_image && image_el?.teaser_image?.length > 0) && {
    src: image_el?.desktop?.url,
    srcTablet: image_el?.tablet?.url,
    srcMobile: image_el?.mobile?.url,
    copyright: {
      title: image_el?.title,
      copyright: image_el?.copyright
    }
  };
  const video = image_el?.teaser_image && image_el?.teaser_image?.length > 0 && {
    imagePlaceholder: image_el?.teaser_image[0]?.desktop?.url,
    imagePlaceholderTablet: image_el?.teaser_image[0]?.tablet?.url,
    imagePlaceholderMobile: image_el?.teaser_image[0]?.mobile?.url,
    src: image_el?.url,
    type: 'VIDEO',
    copyright: {
      title: image_el?.title,
      copyright: image_el?.copyright
    },
    start_second: image_el?.start_second,
    stop_second: image_el?.stop_second
  };
  (0, _react.useEffect)(() => {
    const key = element.id;
    const cachedValue = cachedValues[key];
    if (cachedValue) {
      const aux = cachedValue.page_section_element?.children || cachedValue.page_section_element;
      const array = typeof aux === 'object' ? Object.values(aux) : aux;
      setData(array);
    } else {
      getParagraph(response => {
        setCachedValues({
          ...cachedValues,
          [key]: response
        });
        const aux = response.page_section_element?.children || response.page_section_element;
        const array = typeof aux === 'object' ? Object.values(aux) : aux;
        setData(array);
      }, lang, element.id);
    }
  }, [element.id]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "section-element"
  }, image && /*#__PURE__*/_react.default.createElement(_PagePicture.default, image), video && /*#__PURE__*/_react.default.createElement(_PageMedia.default, {
    items: [video]
  }), title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "sia-text-15 title",
    dangerouslySetInnerHTML: {
      __html: title.replace('<p>', '').replace('</p>', '')
    }
  }), data?.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "element",
      key: `${element.id}-${index}`
    }, /*#__PURE__*/_react.default.createElement(Item, _extends({
      item: el,
      lang: lang,
      history: history
    }, rest)));
  }));
};
const Section = _ref3 => {
  let {
    item,
    lang,
    Item,
    history,
    CustomBottomSection,
    ...rest
  } = _ref3;
  const [selected, setSelected] = (0, _react.useState)(-1);
  const [cachedValues, setCachedValues] = (0, _react.useState)({});
  const array = item.page_section_element?.children || item.page_section_element;
  const sectionSelected = array[selected];
  const Bottom = CustomBottomSection ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, array.map((el, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: i,
    style: {
      opacity: i === selected ? 1 : 0,
      display: i === selected ? 'block' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(CustomBottomSection, _extends({
    element: el,
    Item: Item,
    lang: lang,
    history: history,
    isSelected: i === selected
  }, rest))))) : /*#__PURE__*/_react.default.createElement(BottomSection, _extends({
    key: selected,
    element: sectionSelected,
    Item: Item,
    lang: lang,
    history: history,
    cachedValues: cachedValues,
    setCachedValues: setCachedValues
  }, rest));
  const employee = sectionSelected?.gs_employee_role && sectionSelected?.gs_employee_role[0];
  const hasImage = sectionSelected?.image?.length || 0 > 0;
  const articles = sectionSelected?.website_articles_boxes_are && sectionSelected?.website_articles_boxes_are[0]?.articles;
  const themen_articles = sectionSelected?.themen_articles_boxes_area && sectionSelected?.themen_articles_boxes_area[0]?.articles;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `section-container sia-padding-02-bottom`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${!!employee && employee.data ? 'grid' : ''}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "section-content"
  }, /*#__PURE__*/_react.default.createElement(TopSection, {
    item: item,
    array: array,
    selected: selected,
    setSelected: setSelected,
    history: history
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `bottom-section-container ${hasImage ? 'sia-padding-02-top' : 'sia-padding-05-top'}`
  }, sectionSelected && Bottom)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_GSemployeeRoleItem.default, {
    item: employee && employee.data ? employee : undefined
  }))), articles && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-04-top"
  }, /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, {
    items: articles,
    lang: lang,
    history: history,
    translate: rest.translate
  })), themen_articles && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-04-top"
  }, /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, {
    items: themen_articles,
    lang: lang,
    history: history,
    translate: rest.translate
  })));
};
Section.propTypes = {
  item: _propTypes.default.object.isRequired
};
var _default = exports.default = Section;